/**
 * Get Wallet UseCase
 * Flutter source: WalletNotifier + wallet_data_source.dart
 *
 * Retrieves the wallet entity from SecureStorage.
 */
import { WalletService } from '@/domain/services/wallet/walletService';
import type { WalletEntity } from '@/domain/entities/wallet/walletEntity';

export class GetWalletUseCase {
  private walletService: WalletService;

  constructor(walletService: WalletService = WalletService.getInstance()) {
    this.walletService = walletService;
  }

  async execute(): Promise<WalletEntity | null> {
    return this.walletService.getWalletFromStorage();
  }
}
